import ChatComponent from "./ChatComponent";

export default ChatComponent;